import React from 'react';
import add from './add.svg';
import added from './added.svg';

function Icon({ type, className = '' }) {
  const icons = {
    add,
    added,
    remove: added,
  };

  return <img className={className} src={icons[type]} alt="favorites" />;
}

export default Icon;
